module.exports = __webpack_public_path__ + "assets/img/head.ef77d761.png";